module.exports = __webpack_public_path__ + "img/info-square.b6d0474e.svg";